import React, { useState, useEffect } from "react";
import { useDataProvider, LinearProgress, SelectInput } from "react-admin";

import PropTypes from "prop-types";

const useReferenceEnumInput = (reference, selectInputProps = {}) => {
	const dp = useDataProvider();
	const [isLoading, setIsLoading] = useState(true);
	const [ReferenceEnumInput, setReferenceEnumInput] = useState(() => () => null);
	const [data, setData] = useState(null);

	useEffect(() => {
		setIsLoading(true);
		setReferenceEnumInput(() => ({ variant, props }) => <LinearProgress {...props} />);
		dp.getList(reference, {})
			.then(({ data }) => {
				setData(data);
				setReferenceEnumInput(() => (props) => (
					<SelectInput {...selectInputProps} {...props} choices={data} />
				));
				setIsLoading(false);
			})
			.catch((error) => {
				console.error(error);
			});
		// eslint-disable-next-line
	}, [dp]);

	return {
		isLoading,
		data,
		ReferenceEnumInput,
	};
};

useReferenceEnumInput.proptypes = {
	reference: PropTypes.string.isRequired,
	selectInputProps: PropTypes.shape({
		label: PropTypes.string.isRequired,
		source: PropTypes.string.isRequired,
		optionText: PropTypes.string.isRequired,
		optionValue: PropTypes.string.isRequired,
	}),
};

export default useReferenceEnumInput;
